(() => {
  class StickyHeaderLinks extends HTMLElement {
    constructor() {
      super();

      this.STICKY_CLASS = "sticky-header__wrapper--sticky";
    }

    /**
     * Called when the element is added to the DOM.
     * Sets up the intersection observer.
     */
    connectedCallback() {
      this.addObserver();
    }

    /**
     * Adds the intersection observer to this element.
     */
    addObserver() {
      const observer = this.createObserver();
      observer.observe(this);
    }

    /**
     * Creates an intersection observer for sticky header logic.
     * @returns {IntersectionObserver}
     */
    createObserver() {
      return new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (window.scrollY < 0) return;

            entry.isIntersecting
              ? this.stickyHeader.classList.remove(this.STICKY_CLASS)
              : this.stickyHeader.classList.add(this.STICKY_CLASS);
          });
        },
        this.options
      );
    }

    /** @returns {HTMLElement} The sticky header element */
    get stickyHeader() {
      return this.querySelector("[data-sticky-header]");
    }

    /** @returns {number} The header height */
    get headerHeight() {
      return document.querySelector("[data-header]").offsetHeight;
    }

    /** @returns {Object} Intersection observer options */
    get options() {
      return {
        threshold: 0.95,
        rootMargin: `-${this.headerHeight}px 0px 0px 0px`
      };
    }
  }

  if (!customElements.get("sticky-header-links")) {
    customElements.define("sticky-header-links", StickyHeaderLinks);
  }
})();